<div>
	<ng-template tdLoading [tdLoadingUntil]="!(loading$ | async)" tdLoadingStrategy="replace">
		<pp-eap-services-client-questionnaire-display [questionnaire]="questionnaire$ | async">
		</pp-eap-services-client-questionnaire-display>
	</ng-template>
</div>
